// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const fezandipiti: PokeData = {
  "id": 1016,
  "name": "fezandipiti",
  "height": 14,
  "weight": 301,
  "base_experience": 278,
  "types": [
    PokeType.POISON,
    PokeType.FAIRY
  ],
  "api_moves": [
    "wing-attack",
    "double-kick",
    "peck",
    "quick-attack",
    "poison-gas",
    "swagger",
    "attract",
    "beat-up",
    "flatter",
    "roost",
    "cross-poison",
    "tail-slap",
    "disarming-voice",
    "moonblast"
  ],
  "moves": [
    "double-kick",
    "peck",
    "quick-attack",
    "poison-gas",
    "flatter",
    "roost",
    "moonblast",
    "starfall",
    "dazzling-gleam",
    "acid",
    "mist-terrain",
    "heal-bell",
    "acid-rain"
  ],
  "evolution_chain": {
    "id": 542,
    "item": null,
    "species": [
      {
        "name": "fezandipiti",
        "order": 1018,
        "types": [
          PokeType.POISON,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 134,
    "speed": 139,
    "ability_power": 127
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
